export default "__VITE_ASSET__4Afy8q_B__"